<script>
export default {
    methods: {
        goToDashboard(){
            setTimeout(() => {
                this.$router.push('/dashboard');
            }, 15)
        }
    }
}
</script>

<template>
    <div class="page-not-found-ctr flex-all-centered-row">
            <div class="flex-all-centered-col">
                <div class="dashboard-button" @click="goToDashboard">
                    Back to Dashboard
                </div>
            </div>
    </div>
</template>

<style scoped lang="scss">
    .page-not-found-ctr{
        height: 100vh;
        background-image: url('/images/404.png');
        background-size: 100% 100%;
        background-position: center; 
        background-repeat: no-repeat;
        color: var(--sustainfinity-navy);
        font-family: 'Muli', "Helvetica", Arial, sans-serif;
        font-size: 7.5em;
    }

    .dashboard-button{
        position: absolute;
        -webkit-user-select: none; 
        -moz-user-select: none; 
        -ms-user-select: none;
        user-select: none;

        /* background-color: #02304756; */
        padding: .53em;
        font-size: 2rem;
        border-radius: 1em;
        cursor: pointer;
        /* border: thin solid rgba(0, 0, 0, 0.204); */

        bottom: 5%;
        left: 9%;

        &:hover {
            text-decoration: underline;
        }
    }
</style>